import {markRaw} from 'vue';
import EventBus from '@/lib/event_bus';
import LoginForm from '@/components/forms/login';
import ForgotPasswordForm from '@/components/forms/forgot_password';
import MessageForm from '@/components/forms/message';
import IpConfirmedForm from '@/components/forms/ip_confirmed';
import RefreshIpTokenForm from '@/components/forms/refresh_ip_token';


const LoginFormComponent = markRaw(LoginForm);
const ForgotPasswordComponent = markRaw(ForgotPasswordForm);
const MessageFormComponent = markRaw(MessageForm);
const IpConfirmedComponent = markRaw(IpConfirmedForm);
const RefreshIpTokenComponent = markRaw(RefreshIpTokenForm);


export const showLoginModal = (options) => {
    if (!options) {
        options = {};
    }
    if (!options.title) {
        options.title = 'LOGIN';
    }
    EventBus.emit(EventBus.EVENTS.MODAL_OPEN_REQUEST, {
        component: LoginFormComponent,
        options: options
    });
};

export const showForgotPasswordModal = (options) => {
    if (!options) {
        options = {};
    }
    if (!options.title) {
        options.title = 'FORGOT PASSWORD';
    }
    EventBus.emit(EventBus.EVENTS.MODAL_OPEN_REQUEST, {
        component: ForgotPasswordComponent,
        options: options
    });
};

export const showMessageModal = (options) => {
    EventBus.emit(EventBus.EVENTS.MODAL_OPEN_REQUEST, {
        component: MessageFormComponent,
        options: options
    });
};

export const showIpConfirmedModal = (options) => {
    EventBus.emit(EventBus.EVENTS.MODAL_OPEN_REQUEST, {
        component: IpConfirmedComponent,
        options: options
    });
};

export const showIpTokenRefreshModal = (options) => {
    options = options || {};
    options.title = 'LINK EXPIRED';
    EventBus.emit(EventBus.EVENTS.MODAL_OPEN_REQUEST, {
        component: RefreshIpTokenComponent,
        options: options
    });
};
